"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcRolesGet = exports.AcRoleAssign = exports.AcRoleUpdate = exports.AcRoleDelete = exports.AcRoleCreate = exports.AcRoleReassign = exports.AcRoleAssignDelete = void 0;
const acRoleAssignDelete_gql_1 = __importDefault(require("./acRoleAssignDelete.gql"));
exports.AcRoleAssignDelete = acRoleAssignDelete_gql_1.default;
const acRoleAssign_gql_1 = __importDefault(require("./acRoleAssign.gql"));
exports.AcRoleAssign = acRoleAssign_gql_1.default;
const acRoleReAssign_gql_1 = __importDefault(require("./acRoleReAssign.gql"));
exports.AcRoleReassign = acRoleReAssign_gql_1.default;
const acRoleCreate_gql_1 = __importDefault(require("./acRoleCreate.gql"));
exports.AcRoleCreate = acRoleCreate_gql_1.default;
const acRoleDelete_gql_1 = __importDefault(require("./acRoleDelete.gql"));
exports.AcRoleDelete = acRoleDelete_gql_1.default;
const acRoleUpdate_gql_1 = __importDefault(require("./acRoleUpdate.gql"));
exports.AcRoleUpdate = acRoleUpdate_gql_1.default;
const acRolesGet_gql_1 = __importDefault(require("./acRolesGet.gql"));
exports.AcRolesGet = acRolesGet_gql_1.default;
